import React from 'react';
import CustomButton from './CustomButton';
import '../../styles/ConfirmationPage.css';

/**
 * Компонент страницы подтверждения с кнопками "Подтвердить" и "Отмена".
 * Также поддерживает альтернативный режим с одной кнопкой (если передано `addNew`).
 *
 * @component
 * @param {Object} props - Свойства компонента.
 * @param {function} props.onConfirm - Обработчик нажатия на кнопку подтверждения.
 * @param {function} props.onCancel - Обработчик нажатия на кнопку отмены.
 * @param {string} props.confirmText - Текст  подтверждающего сообщения.
 * @param {string} props.confirmButtonText - Текст на кнопке подтверждения.
 * @param {string} props.cancelButtonText - Текст на кнопке отмены.
 * @param {string} [props.addNew] - Если передано, компонент отрисует одну кнопку с этим текстом и поведением onConfirm.
 * @param {boolean} [props.isDisabledConfirmBtn] - Отключить кнопку подтверждения.
 * @param {boolean} [props.isDisabledCancelBtn] - Отключить кнопку отмены.
 * @param {string} [props.btnWidth] - Ширина кнопок подтверждения/отмены.
 * @param {string} [props.btnHeight] - Высота кнопок подтверждения/отмены.
 * @param {string} [props.setColorCancelBtn] - Кастомный цвет кнопки отмены (фон и текст).
 *
 * @returns {JSX.Element} JSX-элемент ConfirmationPage.
 */

function ConfirmationPage({
  onConfirm,
  onCancel,
  confirmText,
  confirmButtonText,
  cancelButtonText,
  addNew,
  isDisabledConfirmBtn,
  isDisabledCancelBtn,
  btnWidth,
  btnHeight,
  setColorCancelBtn,
}) {
  return (
    <div className="confirmation-container">
      <h5 className="confirmation-title">{confirmText}</h5>
      <div className="confirmation-btn-container">
        {!addNew && (
          <>
            <CustomButton
              className="confirmation-btn confirm"
              width={btnWidth}
              height={btnHeight}
              text={confirmButtonText}
              onClick={(event) => {
                onConfirm(event);
              }}
              disabled={isDisabledConfirmBtn}
            />
            <CustomButton
              className="confirmation-btn cancel"
              width={btnWidth}
              height={btnHeight}
              color={setColorCancelBtn || 'var(--sadr-background-secondary)'}
              colorText={setColorCancelBtn ? 'var(--sadr-background-secondary)' : 'var(--sadr-border)'}
              text={cancelButtonText}
              onClick={onCancel}
              disabled={isDisabledCancelBtn}
            />
          </>
        )}
        {addNew && (
          <CustomButton
            width="var(--sadr-font-size-420)"
            height="var(--sadr-font-size-60)"
            text={addNew}
            onClick={onConfirm}
          />
        )}
      </div>
    </div>
  );
}

export default ConfirmationPage;
